import type { ComponentMultiStyle } from "@yamada-ui/core"

export const InfiniteScrollArea: ComponentMultiStyle<"InfiniteScrollArea"> = {
  baseStyle: {
    container: {},
    trigger: {},
  },

  defaultProps: {},
}
